import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "p-input-icon-left m-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { class: "flex flex-wrap" }
const _hoisted_5 = { class: "flex flex-wrap" }
const _hoisted_6 = { class: "flex flex-wrap" }

import { computed, onBeforeMount, ref } from "vue";
import Fieldset from "primevue/fieldset";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import {
  TargetResponse,
  CombinedTargetResponse,
  ISubscribedTargetResponse,
} from "@evolutivelabs/quokka-common";
import TargetCard from "@/components/TargetCard.vue";
import SubscribedTargetCard from "@/components/SubscribedTargetCard.vue";
import CombinedTargetCard from "@/components/CombinedTargetCard.vue";
import TargetEditorDialog from "@/components/TargetEditorDialog.vue";
import CombinedTargetEditorDialog from "@/components/CombinedTargetEditorDialog.vue";
import TargetShareDialog from "@/components/TargetShareDialog.vue";
import { useTargetStore } from "@/store/target.store";
import { useCombinedTargetStore } from "@/store/combinedTarget.store";
import { storeToRefs } from "pinia";
import { useSubscribedTargetStore } from "@/store/subscribedTarget.store";
import { useUserStore } from "@/store/user.store";
import RenameSubscribeDialog from "@/components/RenameSubscribeDialog.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast();
const userStore = useUserStore();
const targetStore = useTargetStore();
const subscribedTargetStore = useSubscribedTargetStore();
const combinedTargetStore = useCombinedTargetStore();
const { targets, targetDods } = storeToRefs(targetStore);
const { subscribedTargets } = storeToRefs(subscribedTargetStore);
const { combinedTargets } = storeToRefs(combinedTargetStore);
const filteredTargets = computed<TargetResponse[]>(() =>
  targets.value.filter((t) => t.title.includes(filterInput.value))
);
const filteredSubscribedTargets = computed<ISubscribedTargetResponse[]>(() =>
  subscribedTargets.value.filter((t) =>
    t.displayName.includes(filterInput.value)
  )
);
const filteredCombinedTargets = computed<CombinedTargetResponse[]>(() =>
  combinedTargets.value.filter((t) => t.title.includes(filterInput.value))
);

onBeforeMount(async () => {
  await Promise.all([
    userStore.fetch(),
    targetStore.fetch(),
    subscribedTargetStore.fetch(),
    combinedTargetStore.fetch(),
  ]);
});

const targetEditor = ref<InstanceType<typeof TargetEditorDialog>>();
const combinedTargetEditor =
  ref<InstanceType<typeof CombinedTargetEditorDialog>>();
const targetSharer = ref<InstanceType<typeof TargetShareDialog>>();
const subscribeRename = ref<InstanceType<typeof RenameSubscribeDialog>>();

function editTarget(t: TargetResponse) {
  targetEditor.value?.open(t);
}
function editCombinedTarget(t: CombinedTargetResponse) {
  combinedTargetEditor.value?.open(t);
}
function createCombinedTarget() {
  combinedTargetEditor.value?.open();
}
function shareTarget(t: TargetResponse) {
  targetSharer.value?.open(t);
}
function renameSubscribe(t: ISubscribedTargetResponse) {
  subscribeRename.value?.open(t);
}
function showSucceedToast() {
  toast.add({
    severity: "success",
    summary: "Copy Succeed",
    detail: "Email has been copied to clipboard",
    life: 3000,
  });
}
const filterInput = ref("");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(InputText), {
          type: "text",
          modelValue: filterInput.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterInput).value = $event)),
          modelModifiers: { trim: true, lazy: true },
          placeholder: "Search"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_unref(Button), {
        label: "New Combined Target",
        icon: "pi pi-plus",
        onClick: createCombinedTarget
      })
    ]),
    _createVNode(_unref(Fieldset), {
      legend: "Targets:",
      class: "mx-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTargets), (target) => {
            return (_openBlock(), _createBlock(TargetCard, {
              target: target,
              targetDods: _unref(targetDods),
              isSubscribe: false,
              key: target.id,
              onEditTarget: ($event: any) => (editTarget(target)),
              onShareTarget: ($event: any) => (shareTarget(target))
            }, null, 8, ["target", "targetDods", "onEditTarget", "onShareTarget"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(Fieldset), {
      legend: "Share with you:",
      class: "mx-4 mt-2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredSubscribedTargets), (target) => {
            return (_openBlock(), _createBlock(SubscribedTargetCard, {
              target: target,
              key: target.id,
              onRenameSubscribe: ($event: any) => (renameSubscribe(target)),
              onCopySucceed: showSucceedToast
            }, null, 8, ["target", "onRenameSubscribe"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(Fieldset), {
      legend: "Combined Targets:",
      class: "mx-4 mt-2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredCombinedTargets), (combinedTarget) => {
            return (_openBlock(), _createBlock(CombinedTargetCard, {
              "combined-target": combinedTarget,
              key: combinedTarget.id,
              onEditCombinedTarget: ($event: any) => (editCombinedTarget(combinedTarget))
            }, null, 8, ["combined-target", "onEditCombinedTarget"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(TargetEditorDialog, {
      ref: (_value, _refs) => {
        _refs['targetEditor'] = _value
        targetEditor.value = _value
      }
    }, null, 512),
    _createVNode(TargetShareDialog, {
      ref: (_value, _refs) => {
        _refs['targetSharer'] = _value
        targetSharer.value = _value
      }
    }, null, 512),
    _createVNode(RenameSubscribeDialog, {
      ref: (_value, _refs) => {
        _refs['subscribeRename'] = _value
        subscribeRename.value = _value
      }
    }, null, 512),
    _createVNode(CombinedTargetEditorDialog, {
      ref: (_value, _refs) => {
        _refs['combinedTargetEditor'] = _value
        combinedTargetEditor.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})